"use client"
import React from "react"
import { Modal, Tag } from "antd"

const VirtualUnstagingModal = ({ open, onClose, data, onImageClick }) => {
  const lang = localStorage.getItem("language") || "ar"

  // Handle both list and single object formats
  const detail = data?.detail || {}
  const generations = detail.list || (detail.input ? [detail] : [])
  const hasData = generations.length > 0

  return (
    <Modal
      title={
        <div>
          <div className="d-flex">
            <div
              className={
                lang === "ar" ? "r-r-modal-icon-arabic" : "r-r-modal-icon"
              }
            >
              <img
                src="/dashboard/virtua_unstaging.svg"
                alt="Virtual Unstaging"
              />
            </div>
            <div>
              <div className="modal-heading" style={{ marginBottom: 0 }}>
                {lang === "ar" ? "إزالة الأثاث" : "Furniture Removal"}
              </div>
              <p className="modal-timestamp">
                {hasData
                  ? generations[0].date + " " + generations[0].time
                  : lang === "ar"
                  ? "—"
                  : "—"}
              </p>
            </div>
          </div>
        </div>
      }
      open={open}
      onCancel={onClose}
      footer={null}
      width={730}
      bodyStyle={{
        display: "flex",
        flexDirection: "column",
        height: "360px",
        padding: "0 12px",
      }}
    >
      <div style={{ flex: "0 0 auto", paddingTop: 16 }}>
        <p
          style={{
            fontStyle: "italic",
            marginBottom: 12,
            color: "#555",
          }}
        >
          {lang === "ar" ? "إزالة عناصر الأثاث" : "Remove Furniture Items"}
        </p>
      </div>

      <div
        className="scrollable-cards"
        style={{
          flex: "1 1 auto",
          overflowY: "auto",
          marginTop: "10px",
        }}
      >
        {hasData ? (
          generations.map((gen, index) => (
            <div className="quick-edits" key={index}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: 10,
                }}
              >
                <span>
                  <span className="count-container">{`0${index + 1}`}</span>{" "}
                  <span className="modal-div-date">
                    &nbsp; {gen.date} {gen.time}
                  </span>
                </span>
                {gen.status === "success" || gen.status !== "failed" ? (
                  <div>
                    <Tag color="green">
                      {lang === "ar" ? "ناجح" : "Success"}
                    </Tag>
                  </div>
                ) : (
                  <Tag color="red">{lang === "ar" ? "فشل" : "Failed"}</Tag>
                )}
              </div>

              <div
                style={{
                  display: "flex",
                  gap: 16,
                  flexWrap: "wrap",
                }}
              >
                {/* Input */}
                <div
                  style={{
                    flex: 1,
                    border: "1px solid #eee",
                    borderRadius: "10px",
                    padding: "12px",
                    background: "#fafafa",
                    minWidth: "320px",
                  }}
                >
                  <div className="modal-input-label">
                    {lang === "ar" ? "المدخل" : "Input"}
                  </div>
                  <div style={{ position: "relative" }}>
                    <img
                      src={gen.input}
                      alt="input"
                      onClick={() => {
                        if (onImageClick) {
                          onImageClick(
                            gen.input,
                            lang === "ar" ? "إزالة الأثاث" : "Furniture Removal"
                          )
                        }
                      }}
                      style={{
                        width: "100%",
                        maxWidth: "276px",
                        height: "151px",
                        borderRadius: "8px",
                        cursor: onImageClick ? "pointer" : "default",
                        transition: "opacity 0.2s",
                      }}
                      onMouseEnter={(e) => {
                        if (onImageClick) {
                          e.currentTarget.style.opacity = "0.8"
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (onImageClick) {
                          e.currentTarget.style.opacity = "1"
                        }
                      }}
                    />
                    <div
                      style={{
                        position: "absolute",
                        bottom: "8px",
                        left: "8px",
                        background: "rgba(0, 0, 0, 0.7)",
                        color: "#fff",
                        padding: "4px 8px",
                        borderRadius: "4px",
                        fontSize: "8px",
                        fontWeight: "400",
                      }}
                    >
                      {lang === "ar" ? "الصورة الأساسية" : "Base Image"}
                    </div>
                  </div>
                </div>

                {/* Output */}
                <div
                  style={{
                    flex: 1,
                    border: "1px solid #eee",
                    borderRadius: "10px",
                    padding: "12px",
                    background:
                      gen.status === "failed"
                        ? "#fff5f5"
                        : "rgba(250,250,250,0.9)",
                    minWidth: "280px",
                  }}
                >
                  {gen.status === "failed" ? (
                    <div
                      style={{
                        color: "#d93025",
                        border: "1px solid #f5c2c2",
                        borderRadius: "8px",
                        padding: "10px",
                        fontWeight: 500,
                      }}
                    >
                      {lang === "ar" ? "السبب:" : "Reason:"}
                      <br />
                      <span style={{ color: "red" }}>
                        {gen.reason ||
                          (lang === "ar"
                            ? "لم يتم توفير سبب"
                            : "No reason provided")}
                      </span>
                    </div>
                  ) : (
                    <>
                      <div
                        style={{
                          fontSize: "12px",
                          fontWeight: "400",
                          color: "#404040",
                          paddingBottom: "10px",
                        }}
                      >
                        {lang === "ar" ? "الناتج" : "Output"}
                      </div>
                      <img
                        src={gen.output}
                        alt="output"
                        onClick={() => {
                          if (onImageClick) {
                            onImageClick(
                              gen.output,
                              lang === "ar"
                                ? "إزالة الأثاث"
                                : "Furniture Removal"
                            )
                          }
                        }}
                        style={{
                          width: "100%",
                          maxWidth: "276px",
                          height: "151px",
                          borderRadius: "8px",
                          cursor: onImageClick ? "pointer" : "default",
                          transition: "opacity 0.2s",
                        }}
                        onMouseEnter={(e) => {
                          if (onImageClick) {
                            e.currentTarget.style.opacity = "0.8"
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (onImageClick) {
                            e.currentTarget.style.opacity = "1"
                          }
                        }}
                      />
                    </>
                  )}
                </div>
              </div>
            </div>
          ))
        ) : (
          <p
            style={{
              color: "#888",
              textAlign: "center",
              marginTop: 20,
            }}
          >
            {lang === "ar"
              ? "لم يتم العثور على بيانات توليد"
              : "No generation data found"}
          </p>
        )}
      </div>
    </Modal>
  )
}

export default VirtualUnstagingModal
